import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media, usePhone } from '@clds/style-utils';
import { TextSkeleton } from '@cld/skeleton';
import { Header, PillsLayout } from '../CookbookTransformationCard.styled';

const { font, spacing } = globalTheme;

export const TitleSkeleton = styled(TextSkeleton)`
  width: 200px;

  @media ${media.phone({ maxOnly: true })} {
    width: 60%;
    height: ${font.size.xs};
  }
`;

export const RecipeExcerptTextSkeleton = styled(TextSkeleton)<{ wide?: boolean }>`
  height: ${font.size.sm};
  width: 260px;
  max-width: 100%;
  margin-bottom: ${spacing.xl};

  @media ${media.phone({ maxOnly: true })} {
    height: ${font.size.xs};
    width: ${({ wide }) => (wide ? '90%' : '60%')};
    margin-bottom: ${spacing.sm};
  }
`;

const RecipeExcerptSpacing = styled.div`
  margin-bottom: ${spacing.md};
`;

export const RecipeExcerptSkeleton = () => {
  const isPhone = usePhone();

  return (
    <>
      <RecipeExcerptTextSkeleton isLoading wide />
      {isPhone && (
        <>
          <RecipeExcerptTextSkeleton isLoading wide />
          <RecipeExcerptTextSkeleton isLoading />
          <RecipeExcerptSpacing />
        </>
      )}
    </>
  );
};

const ExcerptTabsSkeleton = styled(TextSkeleton)`
  height: ${font.size.sm};
  width: 70%;
  margin-top: ${spacing.xxs};
  margin-bottom: ${spacing.xs};

  @media ${media.phone({ maxOnly: true })} {
    height: ${font.size.xs};
    width: 100%;
    margin-top: 0;
    margin-bottom: ${spacing.sm};
  }
`;
const ExcerptContentSkeleton = styled(TextSkeleton)`
  height: 82px;
  margin-bottom: ${spacing.xs};

  @media ${media.phone({ maxOnly: true })} {
    margin-bottom: 0;
    height: 128px;
  }
`;

export const ExcerptSnippetSkeleton = () => (
  <>
    <ExcerptTabsSkeleton isLoading />
    <ExcerptContentSkeleton isLoading />
  </>
);

export const ButtonSkeleton = styled(TextSkeleton)`
  height: 28px;
  width: 117px;
  margin-left: auto;

  @media ${media.phone({ maxOnly: true })} {
    margin-left: initial;
    align-self: center;
  }
`;

export const ThumbnailSkeleton = styled(TextSkeleton)`
  width: 200px;
  height: 200px;
  align-self: center;

  @media ${media.phone({ maxOnly: true })} {
    margin-bottom: ${spacing.md};
  }
`;

export const StyledPillsLayout = styled(PillsLayout)`
  @media ${media.phone({ maxOnly: true })} {
    margin-bottom: ${spacing.sm};
  }
`;

export const StyledHeader = styled(Header)`
  @media ${media.phone({ maxOnly: true })} {
    margin-bottom: ${spacing.sm};
  }
`;
